import React from "react";

const KPICard = ({
  title,
  value,
  icon,
  trend,
  trendLabel,
  color = "default",
}) => {
  const colors = {
    default: "bg-white",
    blue: "bg-blue-50 border-blue-200",
    green: "bg-green-50 border-green-200",
    yellow: "bg-yellow-50 border-yellow-200",
    red: "bg-red-50 border-red-200",
    purple: "bg-purple-50 border-purple-200",
  };

  const trendColors = {
    up: "text-green-600",
    down: "text-red-600",
    neutral: "text-gray-600",
  };

  return (
    <div
      className={`${colors[color]} p-6 rounded-lg border border-gray-200 shadow-sm`}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="font-nunito text-[14px] text-text mb-2">{title}</p>
          <p className="font-poppins font-semibold text-[24px] text-title">
            {value}
          </p>

          {trend !== undefined && (
            <div className="flex items-center gap-2 mt-2">
              <span
                className={`font-nunito text-[13px] ${trendColors[trend > 0 ? "up" : trend < 0 ? "down" : "neutral"]}`}
              >
                {trend > 0 ? "+" : ""}
                {trend}%
              </span>
              {trendLabel && (
                <span className="font-nunito text-[13px] text-gray-500">
                  vs {trendLabel}
                </span>
              )}
            </div>
          )}
        </div>

        {icon && <div className="text-3xl text-gray-400">{icon}</div>}
      </div>
    </div>
  );
};

export default KPICard;
